import { render, staticRenderFns } from "./AdminCompanyHome.vue?vue&type=template&id=22e16386&scoped=true"
import script from "./AdminCompanyHome.vue?vue&type=script&lang=js"
export * from "./AdminCompanyHome.vue?vue&type=script&lang=js"
import style0 from "./AdminCompanyHome.vue?vue&type=style&index=0&id=22e16386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e16386",
  null
  
)

export default component.exports